var map = {
	"./adi_logo.png": "1606",
	"./favicon.ico": "6e9c",
	"./favicon.svg": "df0b",
	"./nctwcs/favicon_old.svg": "70b0",
	"./nctwcs/logo.png": "892e",
	"./nctwcs/logo_h.png": "05ae",
	"./nctwcs/logo_old.svg": "8169",
	"./nctwcs/party_left.png": "6cd8",
	"./nctwcs/party_right.png": "3b3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";